module.exports = __webpack_public_path__ + "img/DragonsVsPandas_EGM.00d56afb.jpg";